import { render } from "./salidasinventarioshotel.vue?vue&type=template&id=7fc2dce2&scoped=true"
import script from "./salidasinventarioshotel.vue?vue&type=script&lang=js"
export * from "./salidasinventarioshotel.vue?vue&type=script&lang=js"

import "./salidasinventarioshotel.vue?vue&type=style&index=0&id=7fc2dce2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fc2dce2"]])

export default __exports__